import React, {Fragment, Component} from 'react';
import { connect } from 'react-redux';
import {/* Link, */Redirect} from 'react-router-dom';
import {Card, CardHeader, CardContent, Typography, Grid, Button, Icon, IconButton, Avatar} from '@material-ui/core';
import ModalTravelInformation from './ModalTravelInformation';
import { getCheckoutAction, addAction } from "../../../store/actions/index";
import moment from 'moment';
import 'moment/locale/es';
import 'moment-timezone';
//import config from "../../../store/config/config.json"

import Image from './../../../components/Image'
import CircularProgress from '@material-ui/core/CircularProgress';

import IconC from './../../../components/_IconC'

class DetailRatePasses extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            selectedProduct: this.props.selectedProduct,
            selectedPrice: this.props.selectedPrice,
            selectedSearchDate: this.props.selectedSearchDate,
            selectedSearchDestinyDescription: this.props.selectedSearchDestinyDescription,
            isEmptyCart: this.props.isEmptyCart,
            priceButtonSelection: this.props.priceButtonSelection,
            ages: this.props.ages
        };
        this.tokenClient = this.props.tokenClient;
        this.config = require(`../../../store/config/${this.tokenClient}/config.json`);
        this.apiToken = this.config.credential.api.tokenPasses;
        this.nodePrice = this.config.pricing.search;
        this.xCorrelationId = this.props.xCorrelationId;
        this.descriptionCode = this.props.descriptionCode;

    }

    addCheckout = (itemCartSelect) => {
        const extraInfo = {
            "validityStartDate": this.state.selectedSearchDate,
            "descriptionCode": this.descriptionCode,
            "apiToken": this.apiToken
        }

        this.props.dispatchGetCheckout(extraInfo, itemCartSelect,this.tokenClient, this.apiToken, this.xCorrelationId);
        this.setState ({ loading: true  })
    }

    render(){
        const itemCart = this.state.itemsCart

        let isEmptyCart = this.state.isEmptyCart;
        let selectedPrice = this.state.selectedPrice;
        let selectedProduct = this.state.selectedProduct;
        let selectedSearchDate = this.state.selectedSearchDate;
        let selectedSearchDestinyDescription = this.state.selectedSearchDestinyDescription;

        const GetButton = (props) => {
            const loading = this.state.loading  
            return (
                <Fragment>
                    <div className={`containerButtonProgress`}>
                        <div className={`wrapperButtonProgress`}>
                            <Button disabled={loading} onClick={() => this.addCheckout(this.state.selectedPrice.location)} fullWidth variant="contained" color="primary" >
                                Reservar
                            </Button>
                            {loading && <CircularProgress size={24} color="inherit" className={`buttonProgress`} />}
                        </div>
                    </div>
                </Fragment>
            )
        }

        return (
            <Fragment>
            <Card className="card-detail-rate">
                <CardHeader className="card-header" title={<Fragment>
                    <div className="tarifa-head inverse">
                        <div className="content">
                            {isEmptyCart === false ? (<Fragment>
                                <Typography variant="h3" className="title">No hay pase seleccionado</Typography>
                                <Typography>Selecciona una tarifa para continuar</Typography>
                            </Fragment>) : (<Fragment>
                                <Typography variant="h3" className="title">Total Pases </Typography>
                                <div>
                            <Typography><span className="price-currency">{this.config.credential.currency}</span><span className="price"> {this.state.selectedPrice.api.values.search_price.toFixed(0)} </span></Typography>
                                </div>
                            </Fragment>)}
                        </div>
                    </div>
                </Fragment>}/>

                <CardContent className="card-content">
                    {isEmptyCart === false? (<Fragment>
                        <div className="btnResume">
                            <Button fullWidth variant="contained" color="primary" disabled>Reservar</Button>
                        </div>
                        <div className="image py-4 text-center">
                            <Image img={`ticket.png`} alt="No hay pases seleccionados" />
                        </div>
                    </Fragment>)
                    : (<Fragment>
                        <div className="tarifa-detail">
                            <div className="rows-tarifa">
                                <Grid container>
                                    {selectedPrice.prices.individual.map((price, i) =>
                                    <Fragment key={i}>
                                        <Grid item xs={8}>
                                            <Typography>
                                                {price.type == "ADULT" ? 'Pase Adulto ':''}
                                                {price.type == "SENIOR" ? 'Pase Senior ':'' }
                                                {price.type == "YOUTH" ? 'Pase Menor/Joven ':''}
                                                x {price.count}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} className="text-right">
                                            <Typography> {this.config.credential.currency} {price.api.values.search_price.toFixed(0)}</Typography>
                                        </Grid>
                                    </Fragment>
                                    )}
                                </Grid>
                                <hr/>
                                <Grid container className="row row-total">
                                    <Grid item xs={8}>
                                        <Typography>Total Pases</Typography>

                                    </Grid>
                                    <Grid item xs={4} className="text-right">
                                        <Typography> {this.config.credential.currency} {selectedPrice.api.values.search_price.toFixed(0)} </Typography>
                                    </Grid>
                                </Grid>
                                <Typography className="row-total-leyend"><span>(Valor por total de pasajero/s. No incluye gastos)</span></Typography>
                            </div>
                        </div>

                        <div className="btnResume">   
                                {this.props.preload ?
                                    (<GetButton />)
                                    :
                                    (<Redirect to={{
                                        pathname: "/"+this.tokenClient+"/trenes/checkout/",
                                        state:{"reserve":this.props.reserve}
                                        }}  />)
                                }  
                        </div>

                        <div className="card-products">
                            <Card className="card-product" >
                                <CardHeader className="card-header card-header-product"
                                    avatar={<Avatar aria-label="recipe" className="avatar-product">
                                    <Icon>train</Icon></Avatar>}
                                    title={<span>{selectedProduct.label}</span>}
                                />
                                <CardContent className="card-content card-content-product">
                                    <div className="tren passes">
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <div className="textLine">Destino: <span className="resaltado">{selectedSearchDestinyDescription}</span></div>
                                                <div className="textLine">Tipo: <span className="resaltado">{selectedProduct.offersDescription[this.state.priceButtonSelection.product].periodType.description}</span></div>
                                                
                                                <div className="textLine">&nbsp; </div>
                                                <div className="textLine">Clase: <span className="resaltado">{selectedPrice.category.label}</span></div>
                                                <div className="textLine">Válido desde: <span className="resaltado">{moment(selectedProduct.offersDescription[this.state.priceButtonSelection.product].activationPeriod.startDate).locale('es').format('dddd, Do MMM YY').replace('º','')}</span></div>
                                                <div className="textLine">Válido hasta: <span className="resaltado">{moment(selectedProduct.offersDescription[this.state.priceButtonSelection.product].activationPeriod.endDate).locale('es').format('dddd, Do MMM YY').replace('º','')}</span></div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <ModalTravelInformation
                                                    conditions={selectedProduct.offersDescription[this.state.priceButtonSelection.product].conditions}
                                                    title={selectedProduct.label}
                                                    ages={this.state.ages}
                                                    page="passes"
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    </Fragment>)}
                </CardContent>
            </Card>
        </Fragment>
        );
    }
}

const mapStateToProps = reducers => {
    return reducers.checkoutReducer
};

const mapDispatchToProps = dispatch => {
    return {
        dispatchGetCheckout: (extraInfo, itemCart,tokenClient,apiToken,x_correlation_id) =>
            { dispatch(getCheckoutAction(extraInfo,itemCart,tokenClient,apiToken,x_correlation_id))
        },

        dispatchAddAction: (itemsCart,totalPrice, pricesItem, segmentState) => { 
            dispatch(addAction(itemsCart,totalPrice, pricesItem, segmentState))
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DetailRatePasses);

